import { ExpiringDocumentType, ExpiringDocumentsFrequency } from '@vyce/core/src/api/types';

// Roles that should appear in the recipient picker (mirrors the Time & Attendance pattern).
export const TEAMS_RECIPIENT_ROLES = ['Teams:Admin', 'Teams:Manager'];

export const DOCUMENT_TYPES: { value: ExpiringDocumentType; name: string }[] = [
  { value: 'rtw', name: 'Right to Work' },
  { value: 'id', name: 'ID' },
  { value: 'qualification', name: 'Qualifications' },
];

export const ALL_DOCUMENT_TYPES: ExpiringDocumentType[] = DOCUMENT_TYPES.map(d => d.value);

export const FREQUENCY_OPTIONS: { value: ExpiringDocumentsFrequency; name: string }[] = [
  { value: 'daily', name: 'Daily' },
  { value: 'weekly', name: 'Weekly' },
  { value: 'specific_day', name: 'Specific day of month' },
];

// Mon=0 … Sun=6 (matches the API's day_of_week contract).
export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const WEEKDAY_ITEMS = WEEKDAYS.map((name, i) => ({ name, uuid: String(i) }));

export const MONTH_DAY_ITEMS = Array.from({ length: 31 }, (_, i) => ({
  name: String(i + 1),
  uuid: String(i + 1),
}));

// Local hour of the day, uuid '0'..'23'. Alerts go out on the hour, so there is no minute choice.
export const HOUR_ITEMS = Array.from({ length: 24 }, (_, i) => ({
  name: `${String(i).padStart(2, '0')}:00`,
  uuid: String(i),
}));
